import styled from 'styled-components'

export const LocationTitle = styled.div`
    display: flex;
    flex: 1;
    padding: 16px 0 8px 0;
    font-family: Lato, sans-serif;
    font-size: 25px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: -0.5px;
    text-align: left;
    color: #282828;
    margin-bottom: 8px;
`

export const EmbeddedMapFrame = styled.iframe<{ backgroundUrl?: string }>`
    display: flex;
    flex: 1;
    height: 13.625rem;
    width: 100%;
    border-radius: 0.75rem;
    background-image: ${({ backgroundUrl }) => (backgroundUrl ? `url(${backgroundUrl})` : 'none')};
    border: none;
`

export const MapPlaceholderWrapper = styled.div<{ backgroundUrl?: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 13.625rem;
    background-color: #f5f5f5;
    background-image: ${({ backgroundUrl }) => (backgroundUrl ? `url(${backgroundUrl})` : 'none')};
    background-size: cover;
    background-position: center;
    border-radius: 0.75rem;
`
